<template>
  <div id="app">
    <Header :information="information"></Header>
    <router-view/>
    <Footer :information="information"></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
import axios from "axios";
import {baseUrl} from "./api/api";

export default {
  name: 'App',
  data() {
    return {
      information: null
    }
  },
  mounted() {
    console.log('mounted...')

    //网络请求
    axios.get(baseUrl + "/getInfo").then(res => {
      console.log(res);
      if (res.data.code === 200) {
        this.information = res.data.data;
      }
    }).catch(err => {
      console.log(err);
    })

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue